module.exports = __webpack_public_path__ + "img/code.662efc98.jpg";